<template>
  <div
    v-if="announcements.length"
    class="mobile-announcements"
  >
    <vueper-slides
      class="no-shadow"
      :infinite="false"
      :touchable="false"
      autoplay
      fixed-height="170px"
    >
      <template #arrow-left>
        <AcvIconButton
          icon-type="chevron_left"
        />
      </template>

      <template #arrow-right>
        <AcvIconButton
          icon-type="chevron_right"
        />
      </template>

      <vueper-slide
        v-for="slide in announcements"
        :key="slide.key"
        :class="slide.key"
      >
        <template #content>
          <AuctionAccessBanner
            v-if="slide.key === 'auction-access-banner'"
            v-bind="getAnnouncementProperties(slide.key)"
            class="mobile-announcements__banner"
            :class="{ [slide.key]: true }"
            @banner-button-click="emit('show-auction-access-banner')"
          />
          <AcvEulaReviewBanner
            v-if="slide.key === 'eula-review-banner'"
            v-bind="getAnnouncementProperties(slide.key)"
            class="mobile-announcements__banner"
            :class="{ [slide.key]: true }"
          />
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { VueperSlide, VueperSlides } from 'vueperslides';
import useAcvAnnouncements from '@/composables/useAcvAnnouncements';
import AuctionAccessBanner from '@/components/AuctionAccess/AuctionAccessBanner.vue';
import AcvEulaReviewBanner from '@/components/EulaReviewBanner.vue';
import { AcvIconButton } from '@acv/shared-vuejs';
import 'vueperslides/dist/vueperslides.css';

const { announcements, initializeAnnouncements } = useAcvAnnouncements();
onMounted(() => {
  initializeAnnouncements();
});

const emit = defineEmits(['show-auction-access-banner']);

const getAnnouncementProperties = (key) => announcements.value
  .find((slide) => slide.key === key)?.additionalProperties || {};

defineExpose({
  getAnnouncementProperties,
});
</script>

<style lang="scss" scoped>
@use '@/scss/layout';

.mobile-announcements {
  :deep(.vueperslide) {
    > * {
      height: 100%;
    }

    .mobile-announcements__banner {
      .acv-banner__information {
        overflow-y: scroll;
      }

      &.auction-access-banner {
        .acv-banner__icon {
          align-self: center;
        };

        .acv-banner__information {
          max-height: 90px;
        }

        .acv-banner {
          height: 100%;
          justify-content: center;
        }
      }

      &.eula-review-banner {
        padding: 0.75rem 2.75rem 1.25rem;

        .acv-banner__information {
          max-height: 80px;
        }

        .actions .acv-button {
          padding: 0;
        }
      }
    }
  }

  :deep(.vueperslides__bullet) {
    margin-bottom: 0.5rem;
  }
}
</style>
